import React, { Component } from 'react';
import Loading from 'components/Loading/Loading';
import { connect } from 'react-redux';
import '../style.css';

class Footer extends Component {
  render() {
    const {
      nextButtonDisabled, onBack, onNext, updateStatus
    } = this.props;
    const isUpdating = updateStatus === 'LOADING';

    return (
      <div className="Footer fixed-bottom p-3 px-sm-5">
        {onBack && (
          <button
            type="button"
            className="btn btn-secondary btn-lg btn-cursor btn-prev"
            onClick={onBack}
            disabled={isUpdating}
          >
            Back
          </button>
        )}
        {onNext &&
          !isUpdating && (
            <button
              type="submit"
              className="btn btn-primary btn-lg btn-cursor btn-next"
              disabled={nextButtonDisabled}
            >
              Next
            </button>
        )}
        {onNext && isUpdating && <Loading className="btn-next" size="small" />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    updateStatus: state.user.updateStatus
  };
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/Footer/index.js